var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"chatapp-wrap"},[_c('communicationElementLeft',{attrs:{"link_to_communication_in":_vm.link_to_communication_in}}),_vm._v(" "),_c('communicationElementRight',{attrs:{"icons_path_in":_vm.icons_path_in}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }